import { UserNotification, UserNotificationUtilService } from "@scisys-uim/uim-common";
import { AMMUNITION_STOCK_TYPE } from "assets-model";

export class AmmunitionStockNotificationService implements UserNotificationUtilService {

    unableToDismissReason(notification?: UserNotification): string {
      return "Cannot dismiss this action";
    }
  
    canBeDismissed(notification: UserNotification): boolean {
      return false;
    }
  
    getUserMessageType(): string {
      return "AmmunitionStockAction";
    }
  
    getRouteFromLinkData(notification: UserNotification): any[] {
      return AMMUNITION_STOCK_TYPE.searchRouteBase;
    }
  
    getRouteLinkQueryParams(notification: UserNotification) {
      return {
        hasPendingIssueAcknowledgements: true,
      }
    }
  
  }